/*********************************************************************
 * 
 * WARNING: This shader class is automatically generated, any manual 
 * edits will be lost.
 * Last generated: 2019-09-10T09:14:09.302Z
 * 
 ********************************************************************/
import { ShaderBase } from '../ShaderBase';

export type SkyBoxShaderUniforms = {
	uProjection: WebGLUniformLocation,
	uView: WebGLUniformLocation,
	uSkyboxSampler: WebGLUniformLocation
};

export type SkyBoxShaderAttributes = {
	aPosition: number
};

export type SkyBoxShaderSettings = string[];

export class SkyBoxShader extends ShaderBase<SkyBoxShaderUniforms, SkyBoxShaderAttributes> {

    private static fragmentShaderSource = `
uniform samplerCube uSkyboxSampler;
varying vec3 vTexCoords;
void main(){
	gl_FragColor = textureCube(uSkyboxSampler, vTexCoords);
}
`;

    private static vertexShaderSource = `
attribute vec3 aPosition;
uniform mat4 uProjection;
uniform mat4 uView;
varying vec3 vTexCoords;
void main(){
	vTexCoords = aPosition;
	gl_Position = uProjection * uView * vec4(aPosition, 1.0);
}
`;

    protected get warnAttributeMismatch(): boolean {
        return false;
    }
    constructor(gl: WebGLRenderingContext, settings: SkyBoxShaderSettings) {
        super(gl, SkyBoxShader.fragmentShaderSource, SkyBoxShader.vertexShaderSource, settings);
    }

}
        